import type { ThemeConfig } from 'antd';

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#0D9488',
    colorInfo: '#0EA5E9',
    colorSuccess: '#16A34A',
    colorWarning: '#D97706',
    colorError: '#DC2626',
    colorBgLayout: '#F8FAFC',
    colorTextBase: '#0F172A',
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 14,
    borderRadius: 8,
    wireframe: false,
  },
  components: {
    Layout: {
      headerBg: '#FFFFFF',
      siderBg: '#0F172A',
      bodyBg: '#F8FAFC',
    },
    Menu: {
      darkItemBg: '#0F172A',
      darkSubMenuItemBg: '#0F172A',
      darkItemSelectedBg: '#0D9488',
      darkItemHoverBg: '#1E293B',
    },
    Table: {
      headerBg: '#F1F5F9',
      headerColor: '#0F172A',
      rowHoverBg: '#F8FAFC',
      borderColor: '#E2E8F0',
    },
    Card: {
      headerBg: 'transparent',
      borderRadiusLG: 12,
    },
    Button: {
      borderRadius: 8,
      controlHeight: 36,
    },
  },
};
